import styled, { css } from "styled-components";

interface IContainer {
  columns: number;
}

export const Container = styled.section<IContainer>`
  display: grid;
  align-items: center;
  justify-content: center;

  grid-template-columns: ${(props) => `repeat(${props.columns}, 1fr)`};
  gap: 1.5rem;

  width: 100%;

  transition: ease-in-out 0.5s;

  @media (max-width: 530px) {
    gap: 0.75rem;
  }
`;

interface IPaymentMethodContainer {
  active: boolean;
  checked: boolean;
  disabled: boolean;
}

export const PaymentMethodContainer = styled.button<IPaymentMethodContainer>`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 0 1rem;
  height: 3.75rem;

  border-radius: 0.5rem;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  background: ${({ theme }) => theme.checkoutStepsOffers?.inputBackground};

  @media (max-width: 530px) {
    height: 3rem;
    padding: 0 0.5rem;
  }

  ${(props) =>
    !props.disabled &&
    css`
      &:hover {
        border: 0.125rem solid
          ${(props) =>
            `${
              props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
              props.theme?.colors?.primary
            }a0`};
        opacity: 1;
      }
    `}

  ${(props) =>
    props.checked
      ? css`
          border: 0.125rem solid
            ${(props) =>
              `${
                props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
                props.theme?.colors?.primary
              }a8`};
        `
      : css`
          opacity: 0.75;
          border: 0.125rem solid transparent;
        `}

  ${(props) =>
    !props.active &&
    css`
      border: 0.063rem solid
        ${props.theme?.checkoutStepsOffers?.placeholderColor};
      opacity: 0.5;
    `}
`;

export const RadioInput = styled.input`
  appearance: none;

  position: absolute;
  z-index: -1;
`;

export const Label = styled.label`
  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;
